// Домены входов. Единственное место во фронте, где они читаются: бандл ставится
// клиенту, и наших адресов в нём быть не должно — сторож config/no-hardcoded-hosts.test.js
// не даст зашить их снова.
//
// Клиентский вход живёт на своём домене, чтобы не трогать экран сотрудников:
// у него два года привычки, 109 человек в месяц входят по ключу доступа и 211
// заводятся через AI Platform.
//
// 🔴 Запасного значения НЕТ намеренно. До 03.09.2026 здесь стояло боевое
// `newton.1bitai.ru`, а переменной в ENV_prod не было вовсе — то есть прод жил
// на этом запасном значении, и оно же уезжало в каждую стороннюю сборку, включая
// стенд. Теперь переменная задана явно в ENV_prod, а без неё ссылка не рисуется
// вовсе: пустая ссылка честнее, чем ссылка на чужой боевой контур.
const CLIENT_HOST = (process.env.REACT_APP_CLIENT_HOST || '').trim().toLowerCase();
const STAFF_HOST = (process.env.REACT_APP_STAFF_HOST || '').trim().toLowerCase();

export { CLIENT_HOST, STAFF_HOST };

// Адреса для ссылок. Пустая строка — признак «домена нет», по нему компоненты
// решают не рисовать ссылку.
export const CLIENT_URL = CLIENT_HOST ? `https://${CLIENT_HOST}/` : '';
export const STAFF_URL = STAFF_HOST ? `https://${STAFF_HOST}/` : '';

// Страница-предложение Ньютона — куда логотип ведёт сотрудника (решение владельца
// 28.09, вместо демо). Тоже только из переменной: в стороннюю сборку наш адрес
// уезжать не должен, без переменной логотип ведёт на демо, как раньше.
export const PROPOSAL_URL = (process.env.REACT_APP_PROPOSAL_URL || '').trim();

export function isClientHost(hostname) {
  if (!CLIENT_HOST) return false;
  const name = (hostname === undefined ? window.location.hostname : hostname) || '';
  return name.toLowerCase() === CLIENT_HOST;
}
